export default __webpack_public_path__ + "static/media/annimation.4c7d2333.gif";